import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ECOM_OTP_SEND, ECOM_OTP_SEND_ATTEMPT } from '@/configs/ecom/apis';
import is from '@/utils/is';

export const otpSend = async (body: { mobile_number: string; email?: string }): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_OTP_SEND), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const otpSendAttempt = async (body: { mobile_number: string }) => {
  try {
    const response = await axiosInstance.post(ECOM_OTP_SEND_ATTEMPT, body);
    let data = response.data;
    if (is.string(data)) {
      data = JSON.parse(data);
    }

    if (data.success) {
      return data;
    }
    throw new Error(data.message);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
